<template>
  <div class="channel_list_op2">
    <Poptip
      popper-class="channel_price_pop"
      trigger="hover"
      offset="20"
      :placement="placement"
      :transfer="true"
      width="340">
      <span class="ope2">明细</span>
      <div slot="content">
        <div class="channel_ope_rule_title">结算规则明细</div>
        <table class="channel_ope_rule_table">
          <thead>
            <tr>
              <th>序号</th>
              <th>费用类型</th>
              <th>子类型</th>
              <th>底价单价(元)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="3">1</td><td rowspan="3">会员交易</td><td>初级会员</td><td>{{rowData.money_hy_level_base}}</td>
            </tr>
            <tr>
              <td>中级会员</td><td>{{rowData.money_hy_level_mid}}</td>
            </tr>
            <tr>
              <td>高级会员</td><td>{{rowData.money_hy_level_adv}}</td>
            </tr>
            <tr>
              <td rowspan="2">2</td><td rowspan="2">调研交易</td><td>调研次数</td><td>{{rowData.money_config_report}}</td>
            </tr>
            <tr>
              <td>调研报告</td><td>{{rowData.money_config_base_report}}</td>
            </tr>
            <tr>
              <td rowspan="5">3</td><td rowspan="5">会议交易</td><td>直播次数</td><td>{{rowData.money_config_live}}</td>
            </tr>
            <tr>
              <td>会议室1个月</td><td>{{rowData.money_meeting_month_1}}</td>
            </tr>
            <tr>
              <td>会议室3个月</td><td>{{rowData.money_meeting_month_3}}</td>
            </tr>
            <tr>
              <td>会议室6个月</td><td>{{rowData.money_meeting_month_6}}</td>
            </tr>
            <tr>
              <td>会议室1年</td><td>{{rowData.money_meeting_year_1}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Poptip>
  </div>
</template>
<script>
export default {
  name: 'channelOpe2',
  data() {
    return {}
  },
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  computed: {
    placement() {
      const totalHeight = document.querySelector('.normal-right-inner-wrap').getBoundingClientRect().height
      if (totalHeight - 138 - 32 - this.index * 32 < 400) {
        if (totalHeight - 138 - 32 - this.index * 32 < 240) {
          return 'left-end'
        } else {
          return 'left'
        }
      } else {
        return 'left-start'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.ope2 {
  color: #748BA3;
  cursor: pointer;
  text-decoration: underline;
}
.channel_ope_rule_title {
  color: #5D6F80;
  font-size: 12px;
  line-height: 12px;
  font-weight: 600;
  // margin-top: 10px;
  margin-bottom: 10px;
}
.channel_ope_rule_table {
  border-collapse:collapse;
  border: 1px solid #DAE3EA;
  width: 100%;
  tr {
    height: 30px;
  }
  th {
    text-align: left;
    background: #DAE3EA;
    color: #5D6F80;
    font-size: 12px;
    line-height: 30px;
    padding: 0 10px;
  }
  td {
   border: 1px solid #DAE3EA;
   padding: 0 10px;
   line-height: 30px;
   vertical-align: middle;
  }
}
</style>
<style lang="scss">
.channel_price_pop {
  padding: 0px !important;
  /deep/ .ivu-poptip-body {
    padding: 20px !important;
  }
}
</style>
